import React from "react";

export default function InputText({
  label,
  col,
  placeholder,
  value,
  onChange,
  readOnly,
  inputClass,
}) {
  const htmlFor =
    label.replaceAll(" ", "-") || label.replace(/ /g, "-") || label;
  return (
    <>
      <div className={col}>
        <div className="form-group">
          <label className="form-label" htmlFor={htmlFor}>
            {label}
          </label>
          <div className="form-control-wrap">
            <input
              type="text"
              className={`form-control ${inputClass ? inputClass : ""}`}
              id={htmlFor}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              readOnly={readOnly ? true : false}
            />
          </div>
        </div>
      </div>
    </>
  );
}
